export default {
  data() {
    return {
      middle_row_style: {height: '35px',padding:'0px'},
      middle_cell_style: {padding: "0px"},
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/common_page/mixin/middle_table_style.js